(ns common.schema.entities.vault.zap-vault.core
  (:require [common.eid :as eid]
            [common.features.plan :as plan]
            [common.roles :as roles]
            [common.schema.entities.vault.zap-vault :as zap-vault]))

;; Verbatim copy of common.schema.entity-types's existing zap-vault entry
;; (entity_types.cljc around line 2459-2464, using zap-vault-read-check-fn
;; and admin-delete-check-fn defined around lines 331 and 543 there) -
;; required here, not there, to avoid a circular namespace dependency
;; (entity_types.cljc requires this registry). Keep in sync if the
;; originals ever change.
(defn- read-permissions-check-fn
  [{:keys [entity tenant role tenant-plan account account-current-permissions]}]
  (and (plan/available :feature/zap-vault tenant role tenant-plan)
       (or (roles/admin? role)
           (contains? (:account-modules account-current-permissions)
                      :module/zap-vault))
       (or (roles/admin? role)
           (= (:db/id account) (->> entity :common/owner :db/id))
           (some #{(:db/id account)} (->> entity
                                          :zap-vault/members
                                          (mapv eid/eid)))
           (some (->> (:zap-vault/teams entity)
                      (map eid/eid)
                      (set))
                 (:account-team-memberships account-current-permissions)))))

(defn- disable-permissions-check-fn
  [{:keys [tr entity role]}]
  (and (when-not (roles/admin? role)
         (tr :only-admin-can-delete-this-entity))
       (:common/archived? entity)))

(def entity-type-definition
  {:entity-type                  :entity.type/zap-vault
   :schema                       zap-vault/schema
   :name                         {:en "Vault"}
   :plural                       {:en "Vaults"}
   :icon                         :fa-vault
   :read-permissions-check-fn    read-permissions-check-fn
   :disable-permissions-check-fn disable-permissions-check-fn

   ;; zap-vault has no pre-existing legacy dedicated OpenSearch index (its
   ;; legacy common.opensearch.entity-indices entry is an empty map).
   ;; Leaving :search-index? unset lets it default to true (since :search
   ;; is present below), routing dedicated indexing through the newer
   ;; backend.search.dedicated.indexes/init! bootstrap - the index is
   ;; created and re-indexed explicitly as part of this port, matching
   ;; contract-kyc-profile/tenant-kyc-profile's ports (see ai/mistakes.md).
   ;;
   ;; Unlike the kyc profiles, :zap-vault/name is a real stored field (not
   ;; a calculated composite), so no name-materialization caveat applies
   ;; here - it flattens and title-attrs normally.
   :search                       {:result/title-attr :zap-vault/name
                                  :list/default-columns [:zap-vault/name
                                                         :zap-vault/description
                                                         :common/owner
                                                         :common/created-on
                                                         :common/archived?]
                                  :views {:grid {:po-default-field-paths [[:zap-vault/name]
                                                                          [:zap-vault/description]
                                                                          [:common/owner]
                                                                          [:common/created-on]
                                                                          [:common/archived?]]
                                                 :mandatory-field-paths [[:zap-vault/name]]}}}})
